<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-cubes mr-2" />Barang</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Nama Barang">
                        <b-form-input v-model="filter.name" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Jenis">
                        <multiselect v-model="filter.kind" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optKind" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Merk">
                        <multiselect v-model="filter.brand" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optBrand" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3">
                    <b-form-group label="Ada Grade S?">
                        <b-form-select v-model="filter.gradeS">
                            <b-form-select-option value="-1">Semua</b-form-select-option>
                            <b-form-select-option value="1">Ada Grade S</b-form-select-option>
                            <b-form-select-option value="0">Tanpa Grade S</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Berdasarkan Tahun / Generasi?">
                        <b-form-select v-model="filter.hasYear">
                            <b-form-select-option value="-1">Semua</b-form-select-option>
                            <b-form-select-option value="1">Barang Bertahun</b-form-select-option>
                            <b-form-select-option value="0">Barang Tanpa Tahun</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                        <!-- <b-button class="ml-2 btn-dark" @click="downloadItemTemplate()">
                            <i class="fa fa-download mr-2" />Download Template
                        </b-button> -->
                        <!-- <b-button class="ml-2 btn-dark" @click="prepareUploadTemplate()">
                            <i class="fa fa-upload mr-2" />Upload Template
                        </b-button> -->
                        <b-button class="ml-2" variant="success" @click="generateItemMaster()">
                            <i class="fa fa-download mr-2" />Download Master
                        </b-button>
                        <b-button class="ml-2" variant="danger" @click="resetFilter()">
                            <i class="fa fa-eraser mr-2" />Reset Filter
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting :busy="isBusy" :items="items" :fields="fields"
                @sort-changed="onSortChanged" responsive class="mb-3">
                <template v-slot:empty>
                    Tidak ada data barang.
                </template>
                <template v-slot:cell(item)="row">
                    {{ row.item.type }}
                    <div class="small text-muted">{{ row.item.kind }} - {{ row.item.brand }}</div>
                </template>
                <template v-slot:cell(price)="row">
                    <div v-if="row.item.has_year == 1" class="text-muted">Berdasarkan Tahun / Gen</div>
                    <div v-else>Rp. {{ $helper.formatThousand(row.item.price) }}</div>
                </template>
                <template v-slot:cell(adj_batangan)="row">
                    <div v-if="!row.item.isEditing">
                        <div v-if="row.item.has_year == 1" class="text-muted">Berdasarkan Tahun / Gen</div>
                        <div v-else-if="row.item.adj_batangan == null" class="text-muted">Tidak ada Adjustment Batangan
                        </div>
                        <div v-else>Rp. {{ $helper.formatThousand(row.item.adj_batangan) }}</div>
                    </div>
                    <div v-else>
                        <b-form-group label="Batangan">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="row.item.editBatangan"
                                    @input="sanitize(row.index, row.item, 'editBatangan')"
                                    :disabled="row.item.isSubmitting"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </template>
                <template v-slot:cell(adj_grade_s)="row">
                    <div v-if="!row.item.isEditing">
                        <div v-if="row.item.has_year == 1" class="text-muted">Berdasarkan Tahun / Gen</div>
                        <div v-else-if="row.item.adj_grade_s == null" class="text-muted">Tidak ada Grade S</div>
                        <div v-else>Rp. {{ $helper.formatThousand(row.item.adj_grade_s) }}</div>
                    </div>
                    <div v-else>
                        <b-form-group label="Grade S">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="row.item.editGradeS"
                                    @input="sanitize(row.index, row.item, 'editGradeS')"
                                    :disabled="row.item.isSubmitting"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </template>
                <template v-slot:cell(specs)="row">
                    <div v-if="!row.item.isEditing">
                        <div v-if="row.item.has_year == 1" class="text-muted">Berdasarkan Tahun / Gen</div>
                        <div v-else-if="row.item.hasSpecs">
                            <table class="w-100" style="border:none;">
                                <tr v-for="(value, spec, index) in orderSpecs(row.item.specs)"
                                    style="border:none;background-color:unset !important;" :key="'spek-' + index">
                                    <td v-if="value.adj !== ''" style="border:none; padding:0px;width:80px;">{{ spec }}
                                    </td>
                                    <td v-if="value.adj !== ''" style="border:none; padding:0px;">: Rp. {{
            $helper.formatThousand(value.adj) }}</td>
                                </tr>
                            </table>
                        </div>
                        <div v-else class="text-muted">Tidak ada Harga</div>
                    </div>
                    <div v-else>
                        <b-form-group v-for="(value, spec, index) in row.item.editSpecs" :key="'spek-edit-' + index"
                            :label="'Spek ' + spec">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="row.item.editSpecs[spec].adj"
                                    @input="sanitize(row.index, row.item, spec)"
                                    :disabled="row.item.isSubmitting"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </template>
                <template v-slot:cell(dimension)="row">
                    <div v-if="!row.item.isEditingDimension">
                        <div v-if="row.item.length != null && row.item.width != null && row.item.height != null">
                            {{ row.item.length }} x {{ row.item.width }} x {{ row.item.height }} (cm)</div>
                        <div v-else class="text-muted">Tidak ada dimensi</div>

                        <div v-if="row.item.weight != null">{{ row.item.weight }} (gr)</div>
                        <div v-else class="text-muted">Tidak ada berat</div>
                    </div>
                    <div v-else style="min-width: 275px;">
                        <b-form-group label="Dimensi">
                            <b-input-group>
                                <b-input-group-append>
                                    <b-input @keypress="numberOnly" v-model="row.item.editLength"></b-input>
                                    <b-input-group-text>x</b-input-group-text>
                                    <b-input @keypress="numberOnly" v-model="row.item.editWidth"></b-input>
                                    <b-input-group-text>x</b-input-group-text>
                                    <b-input @keypress="numberOnly" v-model="row.item.editHeight"></b-input>
                                    <b-input-group-text>cm</b-input-group-text>
                                </b-input-group-append>
                            </b-input-group>
                            <small class="form-text text-muted">Panjang x Lebar x Tinggi</small>
                        </b-form-group>
                        <b-form-group label="Berat">
                            <b-input-group append="gr">
                                <b-form-input @keypress="numberOnly" v-model=row.item.editWeight></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <div v-if="!row.item.isEditing && !row.item.isEditingDimension">
                        <div v-if="row.item.has_year == 0" style="display:inline-block;">
                            <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail"
                                @click="showDetail('t', row.item.id)">
                                <i class="fa fa-fw fa-info" />
                            </b-button>
                            <!-- <b-button size="sm" class="ml-2" variant="primary" v-b-tooltip.hover.top title="Adjust Harga"
                                @click="toggleEditSpec(row.index, row.item)">
                                <i class="fa fa-fw fa-list-alt" />
                            </b-button> -->
                            <b-button size="sm" class="ml-2" variant="primary" v-b-tooltip.hover.top
                                title="Adjust Dimensi" @click="toggleEditDimension(row.index, row.item)">
                                <i class="fa fa-fw fa-list-alt" />
                            </b-button>
                            <router-link class="ml-2" :to="'/master/barang/t/' + row.item.id">
                                <b-button size="sm" variant="warning" v-b-tooltip.hover.top title="Edit">
                                    <i class='fa fa-fw fa-pencil' />
                                </b-button>
                            </router-link>
                        </div>
                        <div v-else style="display:inline-block;">
                            <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Lihat Tahunan / Generasi"
                                @click='showYears(row.item)'>
                                <i class='fa fa-fw fa-list' />
                            </b-button>
                            <b-button size="sm" class="ml-2" variant="primary" v-b-tooltip.hover.top
                                title="Adjust Dimensi" @click="toggleEditDimension(row.index, row.item)">
                                <i class="fa fa-fw fa-list-alt" />
                            </b-button>
                        </div>
                    </div>
                    <div v-else-if="row.item.isEditing">
                        <b-button size="sm" variant="danger" :disabled="row.item.isSubmitting" v-b-tooltip.hover.top
                            title="Batal Adjust" @click="toggleEditSpec(row.index, row.item)">
                            <i class="fa fa-fw fa-close" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="success" :disabled="row.item.isSubmitting"
                            v-b-tooltip.hover.top title="Simpan" @click="saveSpec(row.index)">
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                    </div>
                    <div v-else-if="row.item.isEditingDimension">
                        <b-button size="sm" variant="danger" :disabled="row.item.isSubmitting" v-b-tooltip.hover.top
                            title="Batal Adjust" @click="toggleEditDimension(row.index, row.item)">
                            <i class="fa fa-fw fa-close" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="success" :disabled="row.item.isSubmitting"
                            v-b-tooltip.hover.top title="Simpan" @click="saveDimension(row.index)">
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                    </div>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange"
                @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-detail" title="Detail Barang" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <DetailBarang :segment="detailSegment" :id="detailId" />
        </b-modal>
        <b-modal id="m-years" title="Daftar Tahun / Generasi" size="xl" no-close-on-backdrop no-close-on-esc
            hide-footer>
            <ListTahun :activeItem="activeItem" @show-detail="showDetailFromYear" />
        </b-modal>
        <b-modal id="m-download" :title="modalTitle" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="status == 0">
                Menyiapkan file Excel, mohon menunggu...
            </div>
            <div v-else-if="status == -1">
                Gagal menyiapkan file Excel.
            </div>
            <div v-else>
                File Excel sudah siap. Tekan tombol dibawah ini untuk download file Excel.
                <div class="mt-2">
                    <a :href="$BASE_FILE_PATH + path" download>
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" />Download Excel Laporan
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
        <input style="opacity: 0; filter:alpha(opacity=0);" ref="fileupload" type="file" @change="onUploadTemplate"
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">

        <b-modal id="m-upload-template" title="Upload Template" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-alert show>
                Upload Template Terakhir :
                <b-row v-for="(item, index) in templateLogs" :key="'template-log-' + index">
                    <b-col md="10">
                        <li class="mb-2">
                            {{ $helper.parseDate(item.upload_at) }} {{ $helper.parseHourMinute(item.upload_at) }}
                            <strong>({{ item.upload_by.fullname }})</strong>
                            <div class="small text-muted" style="margin-left:20px">
                                <span v-if="item.status == 1">ON PROGRESS</span>
                                <span v-if="item.status == 2">FINISHED</span>
                            </div>
                        </li>
                    </b-col>
                    <b-col md="1">
                        <b-button variant="primary" size="sm" :disabled="item.status == 1"
                            @click="downloadTemplateReport(item.report_path)"><i class="fa fa-download" /></b-button>
                    </b-col>
                </b-row>
            </b-alert>
            <hr />
            <div class="mt-4 text-right" v-if="templateOnProgress === 'false'">
                <b-button variant="primary" @click="uploadItemTemplate()">Upload</b-button>
            </div>
            <div class="mt-4 text-right" v-else>
                <b-button variant="primary" disabled @click="uploadItemTemplate()">Upload</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DetailBarang from './DetailBarang.vue'
import ListTahun from './ListTahun.vue'

export default {
    components: {
        DetailBarang, ListTahun
    },
    data() {
        return {

            status: 1, // 1: sukses, 0: loading, -1: error
            path: "",
            modalTitle: "",

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            detailId: 0,
            detailSegment: "t",

            filter: {
                name: "",
                kind: null,
                brand: null,
                gradeS: -1,
                hasYear: -1
            },

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            fields: [
                { key: "item", label: "Barang", sortable: true },
                { key: "specs", label: "Harga" },
                { key: "adj_batangan", label: "Adj. Batangan", sortable: true },
                { key: "adj_grade_s", label: "Adj. Grade S", sortable: true },
                // { key: "price", label: "Harga Dasar", sortable: true },
                { key: "dimension", label: "Dimensi & Berat", thClass: "dimension-column", tdClass: "dimension-column" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: [],
            optBrand: [],

            templateLogs: [],
            templateOnProgress: ""

        }
    },

    watch: {

        "filter.kind": function (newVal) {

            this.filter.brand = null
            this.optBrand = []

            if (newVal != null) {

                this.$axios.get("master/brands/" + this.filter.kind.id).then(res => {
                    this.optBrand = res.data.data
                    sessionStorage.setItem("listBarangFilter", JSON.stringify(this.filter))
                })

            }

        }

    },

    methods: {

        downloadItemTemplate() {

            this.modalTitle = "Template Item"
            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("master/item/download-excel-template").then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

        generateItemMaster() {
            this.modalTitle = "Master Item"
            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("master/item/download-excel-master").then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

        prepareUploadTemplate() {

            this.$axios.get("master/item/upload-template-log?count=5").then(res => {
                this.templateLogs = res.data.data
            })

            this.$axios.get("master/item/allow-upload-template").then(res => {
                this.templateOnProgress = res.data.data
            })

            this.$bvModal.show('m-upload-template')
        },

        downloadTemplateReport(path) {
            window.open(this.$BASE_FILE_PATH + path)
        },

        uploadItemTemplate() {
            this.$refs.fileupload.click()
        },

        onUploadTemplate(e) {
            this.initStatus = 0
            // this.modalTitle = "Laporan Upload"
            // this.$bvModal.show("m-download")
            this.status = 0
            let payload = new FormData()
            payload.append("file", e.target.files[0])

            this.$axios.post("master/item/upload-excel-template", payload).then(res => {
                // this.status = 1
                // this.path = res.data.data.path
            })
                .catch(error => {
                    // this.initStatus = -1
                    this.$helper.parseError(this, error)
                })
            // .finally(() => {
            // })
            this.$bvModal.hide('m-upload-template')
            this.$helper.toastSuccess(this, "Template sedang di-proses!")
            this.getItems()
            this.initStatus = 1
            this.$refs.fileupload.value = null
        },

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getMasterKind = this.$axios.get("master/kinds").then(res => {
                this.optKind = res.data.data
            })

            Promise.all([getItems, getMasterKind]).then(() => {
                this.initStatus = 1
            })
                .catch(error => {
                    this.initStatus = -1
                })

        },

        showDetail(segment, id) {
            this.detailId = id
            this.detailSegment = segment
            this.$bvModal.show('m-detail')
        },

        showYears(item) {
            this.activeItem = item
            this.$bvModal.show('m-years')
        },

        showDetailFromYear(id) {
            this.showDetail('y', id)
        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if (isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name
            }

            if (this.filter.kind != null) {
                param += "&filterKind=" + this.filter.kind.id
            }

            if (this.filter.brand != null) {
                param += "&filterBrand=" + this.filter.brand.id
            }

            if (this.filter.gradeS != -1) {
                param += "&filterGradeS=" + this.filter.gradeS
            }

            if (this.filter.hasYear != -1) {
                param += "&filterHasYear=" + this.filter.hasYear
            }

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("master/item" + param).then(res => {
                this.items = res.data.data.items.map(item => {
                    let editSpecs = {}
                    let specs = {}
                    let hasSpecs = false
                    for (let i = 0; i < item.itemSpecs.length; i++) {
                        editSpecs[item.itemSpecs[i].name] = {
                            id: item.itemSpecs[i].id,
                            adj: ""
                        }
                        specs[item.itemSpecs[i].name] = {
                            id: item.itemSpecs[i].id,
                            adj: ""
                        }
                        for (let j = 0; j < item.typePrices.length; j++) {
                            if (item.itemSpecs[i].id == item.typePrices[j].id) {
                                specs[item.itemSpecs[i].name].adj = item.typePrices[j].price
                                hasSpecs = true
                                break
                            }
                        }
                    }
                    return {
                        id: item.id,
                        type: item.type,
                        price: item.price,
                        has_year: item.has_year,
                        adj_batangan: item.adj_batangan,
                        adj_grade_s: item.adj_grade_s,
                        brand: item.brand,
                        kind: item.kind,
                        specs: specs,
                        editBatangan: "",
                        editGradeS: "",
                        editSpecs: editSpecs,
                        hasSpecs: hasSpecs,
                        isEditing: false,
                        isSubmitting: false,
                        length: item.length,
                        width: item.width,
                        height: item.height,
                        weight: item.weight,
                        isEditingDimension: false,
                        editLength: "",
                        editWidth: "",
                        editHeight: "",
                        editWeight: ""
                    }
                })
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listBarangFilter", JSON.stringify(this.filter))
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        toggleEditSpec(index, item) {
            if (!this.items[index].isEditing) {
                this.items[index].editBatangan = this.items[index].adj_batangan
                this.items[index].editGradeS = this.items[index].adj_grade_s
                for (const [key, value] of Object.entries(this.items[index].specs)) {
                    this.items[index].editSpecs[key].adj = value.adj
                }
                this.items[index].isEditing = true
            }
            else {
                this.items[index].editBatangan = ""
                this.items[index].editGradeS = ""
                for (const [key, _] of Object.entries(this.items[index].editSpecs)) {
                    this.items[index].editSpecs[key].adj = ""
                }
                this.items[index].isEditing = false
            }

            this.sanitizeAll(index, item)
        },

        saveSpec(index) {

            this.items[index].isSubmitting = true

            // this.items[index].editSpecs.BM.adj = (this.items[index].editSpecs.BM.adj ? this.$helper.toNumber(this.items[index].editSpecs.BM.adj) : null)
            //this.items[index].editSpecs.DISTRI.adj = (this.items[index].editSpecs.DISTRI.adj ? this.$helper.toNumber(this.items[index].editSpecs.DISTRI.adj) : null)
            // this.items[index].editSpecs.REKONDISI.adj = (this.items[index].editSpecs.REKONDISI.adj ? this.$helper.toNumber(this.items[index].editSpecs.REKONDISI.adj) : null)
            this.items[index].editSpecs.RESMI.adj = (this.items[index].editSpecs.RESMI.adj ? this.$helper.toNumber(this.items[index].editSpecs.RESMI.adj) : null)

            let payload = {
                id: this.items[index].id,
                adjBatangan: this.items[index].editBatangan != "" ? this.$helper.toNumber(this.items[index].editBatangan) : null,
                adjS: (this.items[index].editGradeS ? this.$helper.toNumber(this.items[index].editGradeS) : null),
                adjSpec: Object.entries(this.items[index].editSpecs).map(item => item[1]),
                part: "t"
            }

            this.$axios.post("master/item/update-simple", payload).then(res => {
                if (res.status == 200) {
                    this.$helper.toastSuccess(this, "Adjustment harga berhasil disimpan!")
                    this.items[index].editBatangan = ""
                    this.items[index].editGradeS = ""
                    for (const [key, _] of Object.entries(this.items[index].editSpecs)) {
                        this.items[index].editSpecs[key].adj = ""
                    }
                    this.items[index].isEditing = false
                    this.items[index].isSubmitting = false
                    this.getItems()
                }
                else {
                    this.$helper.toastError(this, "Terjadi kesalahan pada server, silahkan coba lagi")
                    this.items[index].isSubmitting = false
                }
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.items[index].isSubmitting = false
                })
        },

        toggleEditDimension(index, item) {
            if (!this.items[index].isEditingDimension) {
                this.items[index].editLength = this.items[index].length
                this.items[index].editWidth = this.items[index].width
                this.items[index].editHeight = this.items[index].height
                this.items[index].editWeight = this.items[index].weight
                this.items[index].isEditingDimension = true
            } else {
                this.items[index].editLength = ""
                this.items[index].editWidth = ""
                this.items[index].editHeight = ""
                this.items[index].editWeight = ""
                this.items[index].isEditingDimension = false
            }
        },

        saveDimension(index) {
            this.items[index].isSubmitting = true
            let payload = {
                id: this.items[index].id,
                length: this.items[index].editLength,
                width: this.items[index].editWidth,
                height: this.items[index].editHeight,
                weight: this.items[index].editWeight
            }

            this.$axios.post("master/item/update-dimension", payload).then(res => {
                if (res.status == 200) {
                    this.$helper.toastSuccess(this, "Dimensi barang berhasil disimpan!")
                    this.items[index].editLength = ""
                    this.items[index].editWidth = ""
                    this.items[index].editHeight = ""
                    this.items[index].editWeight = ""
                    this.items[index].isEditingDimension = false
                    this.items[index].isSubmitting = false
                    this.getItems()
                } else {
                    this.$helper.toastError(this, "Terjadi kesalahan pada server, silahkan coba lagi")
                    this.items[index].isSubmitting = false
                }
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.items[index].isSubmitting = false
                })
        },

        sanitizeAll(index, item) {
            this.sanitize(index, item, "editBatangan")
            this.sanitize(index, item, "editGradeS")
            this.sanitize(index, item, "BM")
            //this.sanitize(index, item, "DISTRI")
            this.sanitize(index, item, "REKONDISI")
            this.sanitize(index, item, "RESMI")
        },

        sanitize(index, item, column) {
            if (column == "editBatangan") {
                let cleaned = String(item.editBatangan).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editBatangan = res
            } else if (column == "editGradeS") {
                let cleaned = String(item.editGradeS).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editGradeS = res
            } else if (column == "BM") {
                let cleaned = String(item.editSpecs.BM.adj).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editSpecs.BM.adj = res
            } else if (column == "REKONDISI") {
                let cleaned = String(item.editSpecs.REKONDISI.adj).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editSpecs.REKONDISI.adj = res
            } else if (column == "RESMI") {
                let cleaned = String(item.editSpecs.RESMI.adj).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editSpecs.RESMI.adj = res
            }
            // else if(column == "DISTRI"){
            //     let cleaned = String(item.editSpecs.DISTRI.adj).replace(/\./g, "")
            //     let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            //     item.editSpecs.DISTRI.adj = res
            // }
        },

        numberOnly(event) {
            if (event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13) {
                return true
            } else {
                event.preventDefault()
            }
        },

        resetFilter() {
            this.filter = {
                name: "",
                kind: null,
                brand: null,
                gradeS: -1,
                hasYear: -1
            }
            this.getItems()
        },
        orderSpecs(specs) {

            console.log("specs", specs)

            let order = {
                "RESMI": { adj: "" },
                "LN": { adj: "" },
                "RR": { adj: "" }
            }

            for (const [key, value] of Object.entries(specs)) {
                if (key == "RESMI") {
                    order.RESMI.adj = value.adj
                } else if (key == "LN") {
                    order.LN.adj = value.adj
                } else if (key == "RR") {
                    order.RR.adj = value.adj
                }
            }

            return order


        }

    },

    created() {
        if (!this.$helper.isBlank(sessionStorage.getItem("listBarangFilter"))) {
            this.filter = JSON.parse(sessionStorage.getItem("listBarangFilter"))
        }
        this.init()
    },


}
</script>

<style scoped>
/deep/.dimension-column {
    max-width: 300px;
}
</style>
